// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nav_nav__CfI3F {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(var(--gutter) / var(--golden-ratio)) var(--gutter);
  min-height: var(--nav-height);
  background: var(--color-surface-light);
  border-bottom: 1px solid var(--color-border);
  z-index: 998;
}
.Nav_nav__title__Xfbcx {
  display: flex;
  align-items: center;
  gap: calc(var(--gutter) / 8);
  font-weight: 900;
  text-transform: uppercase;
  text-decoration: none;
  color: var(--color-text);
}
.Nav_nav__title__Xfbcx svg {
  width: auto;
  height: 20px;
}
.Nav_nav__title__Xfbcx span {
  font-style: italic;
}
.Nav_nav__left__G9wLq {
  display: flex;
  align-items: center;
  gap: calc(var(--gutter) / 1.25);
}
.Nav_nav__departmentSelector__Lg3FO {
  max-width: 200px;
  min-width: 150px;
}
.Nav_nav__departmentSelector__Lg3FO .select-container {
  margin-bottom: 0;
}
.Nav_nav__departmentSelector__Lg3FO .select-label {
  display: none;
}
.Nav_nav__links__hzVIo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.Nav_nav__link__ts6RJ {
  color: var(--color-text-subtle);
  font-weight: 500;
  cursor: pointer;
  transition: color 0.1s;
  text-decoration: none;
  padding: calc(0.75rem / var(--golden-ratio)) 0.75rem;
  border: 1px solid transparent;
  border-radius: var(--radius-full);
}
.Nav_nav__link__ts6RJ.Nav_active__3h2eF {
  color: var(--color-text);
  cursor: default;
  background: var(--color-surface-interactive);
  border: 1px solid var(--color-border);
}
.Nav_nav__link__ts6RJ:hover:not(.Nav_active__3h2eF) {
  color: var(--color-text);
  border: 1px solid var(--color-border);
}
.Nav_nav__userDropdown__CFfiF {
  position: relative;
  margin-left: 1rem;
}
.Nav_nav__user__5BKcr {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.875rem;
  border-radius: var(--radius-full);
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 0.1s, border 0.1s;
}
.Nav_nav__user__5BKcr:hover {
  border: 1px solid var(--color-border);
  background-color: var(--color-surface);
}
.Nav_nav__avatar__Q3zGT {
  flex-shrink: 0;
}
.Nav_nav__dropdownIcon__v5BqN {
  font-size: 8px;
  color: var(--color-text-subtle);
}
.Nav_nav__dropdown__YCwTL {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  width: 100%;
  min-width: 120px;
  background: var(--color-surface-light);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-default);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.Nav_nav__userRole__dEi-c {
  font-size: var(--font-size-smaller);
  color: var(--color-text-subtle);
  padding: 0.25rem 0.5rem 0.5rem;
  border-bottom: 1px solid var(--color-border);
}
.Nav_nav__roleValue__-okKp {
  font-weight: 600;
  color: var(--color-text);
  text-transform: capitalize;
}
.Nav_nav__dropdownButton__kzWo7 {
  width: 100%;
  justify-content: center;
}
.Nav_nav__menuButton__ohx7i {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  margin-left: auto;
  position: relative;
  z-index: 1000;
}
.Nav_nav__menuButton_hidden__BURun {
  display: none !important;
}
.Nav_nav__hamburger__gj8YT {
  width: 24px;
  height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.Nav_nav__hamburgerLine__qhoFw {
  display: block;
  width: 24px;
  height: 2px;
  background-color: var(--color-text);
  border-radius: 1px;
}
.Nav_nav__mobileMenu__yVd6G {
  position: fixed;
  top: 0;
  right: -100%;
  width: 80%;
  max-width: 320px;
  height: 100vh;
  background-color: var(--color-surface-light);
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  transition: right 0.3s ease;
  overflow-y: auto;
}
.Nav_nav__mobileMenu_open__0kokj {
  right: 0;
}
.Nav_nav__mobileMenuContent__kxTLS {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
}
.Nav_nav__mobileDepartmentSelector__NrSgT {
  margin: 1rem 0;
}
.Nav_nav__mobileDepartmentSelector__NrSgT .select-container {
  margin-bottom: 0;
}
.Nav_nav__mobileMenuHeader__qt8mr {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-border);
}
.Nav_nav__closeButton__Pg0hK {
  background: none;
  border: none;
  font-size: var(--font-size-larger);
  cursor: pointer;
  color: var(--color-text);
  padding: 0.5rem;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Nav_nav__mobileLinks__j-qpZ {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 1.5rem;
}
.Nav_nav__mobileLink__jux0D {
  color: var(--color-text);
  font-weight: 500;
  font-size: var(--font-size-larger);
  text-decoration: none;
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--color-border-subtle);
}
.Nav_nav__mobileLink__jux0D.Nav_active__3h2eF {
  color: var(--color-primary);
}
.Nav_nav__mobileUser__cS\\+X1 {
  margin-top: auto;
  padding-top: 1rem;
  border-top: 1px solid var(--color-border);
}
.Nav_nav__mobileUserInfo__ZSf6E {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.Nav_nav__mobileUserDetails__XKy1M {
  display: flex;
  flex-direction: column;
}
.Nav_nav__mobileUserDetails__XKy1M span:first-child {
  line-height: 0.75rem;
}
.Nav_nav__mobileUserRole__2whBg {
  font-size: var(--font-size-smaller);
  color: var(--color-text-subtle);
}
.Nav_nav__mobileLogout__TtEgg {
  width: 100%;
  justify-content: center;
}

@media (max-width: 1000px) {
  .Nav_nav__links__hzVIo {
    display: none;
  }
  .Nav_nav__menuButton__ohx7i {
    display: block;
  }
  .Nav_nav__departmentSelector__Lg3FO {
    margin: 0 auto 0 1rem;
    min-width: 120px;
  }
}
@media (max-width: 480px) {
  .Nav_nav__departmentSelector__Lg3FO {
    max-width: 120px;
    min-width: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Nav/Nav.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gEAAA;EACA,6BAAA;EACA,sCAAA;EACA,4CAAA;EACA,YAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;AACN;AAEI;EACE,kBAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,+BAAA;AAFJ;AAKE;EACE,gBAAA;EACA,gBAAA;AAHJ;AAMI;EACE,gBAAA;AAJN;AAOI;EACE,aAAA;AALN;AASE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAPJ;AAUE;EACE,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,oDAAA;EACA,6BAAA;EACA,iCAAA;AARJ;AAUI;EACE,wBAAA;EACA,eAAA;EACA,4CAAA;EACA,qCAAA;AARN;AAWI;EACE,wBAAA;EACA,qCAAA;AATN;AAaE;EACE,kBAAA;EACA,iBAAA;AAXJ;AAcE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,iCAAA;EACA,6BAAA;EACA,eAAA;EACA,8CAAA;AAZJ;AAcI;EACE,qCAAA;EACA,sCAAA;AAZN;AAgBE;EACE,cAAA;AAdJ;AAiBE;EACE,cAAA;EACA,+BAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,sCAAA;EACA,qCAAA;EACA,oCAAA;EACA,wCAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAhBJ;AAmBE;EACE,mCAAA;EACA,+BAAA;EACA,8BAAA;EACA,4CAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,wBAAA;EACA,0BAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,uBAAA;AAnBJ;AAuBE;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;AArBJ;AAuBI;EACE,wBAAA;AArBN;AAyBE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAvBJ;AA0BE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;AAxBJ;AA4BE;EACE,eAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,4CAAA;EACA,0CAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;AA1BJ;AA4BI;EACE,QAAA;AA1BN;AA8BE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AA5BJ;AA+BE;EACE,cAAA;AA7BJ;AAgCI;EACE,gBAAA;AA9BN;AAkCE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4CAAA;AAhCJ;AAmCE;EACE,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,wBAAA;EACA,gBAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;EACA,mDAAA;AAnCJ;AAqCI;EACE,2BAAA;AAnCN;AAuCE;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AArCJ;AAwCE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAtCJ;AAyCE;EACE,aAAA;EACA,sBAAA;AAvCJ;AAyCI;EACE,oBAAA;AAvCN;AA2CE;EACE,mCAAA;EACA,+BAAA;AAzCJ;AA4CE;EACE,WAAA;EACA,uBAAA;AA1CJ;;AA+CA;EAEI;IACE,aAAA;EA7CJ;EAgDE;IACE,cAAA;EA9CJ;EAiDE;IACE,qBAAA;IACA,gBAAA;EA/CJ;AACF;AAoDA;EAEI;IACE,gBAAA;IACA,gBAAA;EAnDJ;AACF","sourcesContent":[".nav {\n  position: sticky;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: calc(var(--gutter) / var(--golden-ratio)) var(--gutter);\n  min-height: var(--nav-height);\n  background: var(--color-surface-light);\n  border-bottom: 1px solid var(--color-border);\n  z-index: 998;\n\n  &__title {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--gutter) / 8);\n    font-weight: 900;\n    text-transform: uppercase;\n    text-decoration: none;\n    color: var(--color-text);\n\n    svg {\n      width: auto;\n      height: 20px;\n    }\n\n    span {\n      font-style: italic;\n    }\n  }\n\n  &__left {\n    display: flex;\n    align-items: center;\n    gap: calc(var(--gutter) / 1.25);\n  }\n\n  &__departmentSelector {\n    max-width: 200px;\n    min-width: 150px;\n    \n    // Override Select component's default styles for the nav\n    :global(.select-container) {\n      margin-bottom: 0;\n    }\n    \n    :global(.select-label) {\n      display: none;\n    }\n  }\n\n  &__links {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: .5rem;\n  }\n\n  &__link {\n    color: var(--color-text-subtle);\n    font-weight: 500;\n    cursor: pointer;\n    transition: color 0.1s;\n    text-decoration: none;\n    padding: calc(0.75rem / var(--golden-ratio)) 0.75rem;\n    border: 1px solid transparent;\n    border-radius: var(--radius-full);\n\n    &.active {\n      color: var(--color-text);\n      cursor: default;\n      background: var(--color-surface-interactive);\n      border: 1px solid var(--color-border);\n    }\n\n    &:hover:not(.active) {\n      color: var(--color-text);\n      border: 1px solid var(--color-border);\n    }\n  }\n\n  &__userDropdown {\n    position: relative;\n    margin-left: 1rem;\n  }\n\n  &__user {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.375rem 0.875rem;\n    border-radius: var(--radius-full);\n    border: 1px solid transparent;\n    cursor: pointer;\n    transition: background-color 0.1s, border 0.1s;\n\n    &:hover {\n      border: 1px solid var(--color-border);\n      background-color: var(--color-surface);\n    }\n  }\n\n  &__avatar {\n    flex-shrink: 0;\n  }\n\n  &__dropdownIcon {\n    font-size: 8px;\n    color: var(--color-text-subtle);\n  }\n\n  &__dropdown {\n    position: absolute;\n    top: calc(100% + 4px);\n    right: 0;\n    width: 100%;\n    min-width: 120px;\n    background: var(--color-surface-light);\n    border: 1px solid var(--color-border);\n    border-radius: var(--radius-default);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    z-index: 999;\n    padding: 0.5rem;\n    display: flex;\n    flex-direction: column; \n    gap: 0.5rem;\n  }\n\n  &__userRole {\n    font-size: var(--font-size-smaller);\n    color: var(--color-text-subtle);\n    padding: 0.25rem 0.5rem 0.5rem;\n    border-bottom: 1px solid var(--color-border);\n  }\n\n  &__roleValue {\n    font-weight: 600;\n    color: var(--color-text);\n    text-transform: capitalize;\n  }\n\n  &__dropdownButton {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  // Mobile menu button (hamburger)\n  &__menuButton {\n    display: none;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 0.5rem;\n    margin-left: auto;\n    position: relative;\n    z-index: 1000;\n    \n    &_hidden {\n      display: none !important;\n    }\n  }\n  \n  &__hamburger {\n    width: 24px;\n    height: 18px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n  \n  &__hamburgerLine {\n    display: block;\n    width: 24px;\n    height: 2px;\n    background-color: var(--color-text);\n    border-radius: 1px;\n  }\n  \n  // Mobile off-canvas menu\n  &__mobileMenu {\n    position: fixed;\n    top: 0;\n    right: -100%;\n    width: 80%;\n    max-width: 320px;\n    height: 100vh;\n    background-color: var(--color-surface-light);\n    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);\n    z-index: 999;\n    transition: right 0.3s ease;\n    overflow-y: auto;\n    \n    &_open {\n      right: 0;\n    }\n  }\n  \n  &__mobileMenuContent {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 1rem;\n  }\n  \n  &__mobileDepartmentSelector {\n    margin: 1rem 0;\n    \n    // Override Select component's default styles for the nav\n    :global(.select-container) {\n      margin-bottom: 0;\n    }\n  }\n  \n  &__mobileMenuHeader {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid var(--color-border);\n  }\n  \n  &__closeButton {\n    background: none;\n    border: none;\n    font-size: var(--font-size-larger);\n    cursor: pointer;\n    color: var(--color-text);\n    padding: 0.5rem;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  &__mobileLinks {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin-top: 1.5rem;\n  }\n  \n  &__mobileLink {\n    color: var(--color-text);\n    font-weight: 500;\n    font-size: var(--font-size-larger);\n    text-decoration: none;\n    padding: 0.75rem 0;\n    border-bottom: 1px solid var(--color-border-subtle);\n    \n    &.active {\n      color: var(--color-primary);\n    }\n  }\n  \n  &__mobileUser {\n    margin-top: auto;\n    padding-top: 1rem;\n    border-top: 1px solid var(--color-border);\n  }\n  \n  &__mobileUserInfo {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  &__mobileUserDetails {\n    display: flex;\n    flex-direction: column;\n\n    span:first-child {\n      line-height: 0.75rem;\n    }\n  }\n\n  &__mobileUserRole {\n    font-size: var(--font-size-smaller);\n    color: var(--color-text-subtle);\n  }\n  \n  &__mobileLogout {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n// Media query for mobile view\n@media (max-width: 1000px) {\n  .nav {\n    &__links {\n      display: none;\n    }\n    \n    &__menuButton {\n      display: block;\n    }\n    \n    &__departmentSelector {\n      margin: 0 auto 0 1rem;\n      min-width: 120px;\n    }\n  }\n}\n\n// Media query for very small screens\n@media (max-width: 480px) {\n  .nav {\n    &__departmentSelector {\n      max-width: 120px;\n      min-width: 100px;\n    }\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": `Nav_nav__CfI3F`,
	"nav__title": `Nav_nav__title__Xfbcx`,
	"nav__left": `Nav_nav__left__G9wLq`,
	"nav__departmentSelector": `Nav_nav__departmentSelector__Lg3FO`,
	"nav__links": `Nav_nav__links__hzVIo`,
	"nav__link": `Nav_nav__link__ts6RJ`,
	"active": `Nav_active__3h2eF`,
	"nav__userDropdown": `Nav_nav__userDropdown__CFfiF`,
	"nav__user": `Nav_nav__user__5BKcr`,
	"nav__avatar": `Nav_nav__avatar__Q3zGT`,
	"nav__dropdownIcon": `Nav_nav__dropdownIcon__v5BqN`,
	"nav__dropdown": `Nav_nav__dropdown__YCwTL`,
	"nav__userRole": `Nav_nav__userRole__dEi-c`,
	"nav__roleValue": `Nav_nav__roleValue__-okKp`,
	"nav__dropdownButton": `Nav_nav__dropdownButton__kzWo7`,
	"nav__menuButton": `Nav_nav__menuButton__ohx7i`,
	"nav__menuButton_hidden": `Nav_nav__menuButton_hidden__BURun`,
	"nav__hamburger": `Nav_nav__hamburger__gj8YT`,
	"nav__hamburgerLine": `Nav_nav__hamburgerLine__qhoFw`,
	"nav__mobileMenu": `Nav_nav__mobileMenu__yVd6G`,
	"nav__mobileMenu_open": `Nav_nav__mobileMenu_open__0kokj`,
	"nav__mobileMenuContent": `Nav_nav__mobileMenuContent__kxTLS`,
	"nav__mobileDepartmentSelector": `Nav_nav__mobileDepartmentSelector__NrSgT`,
	"nav__mobileMenuHeader": `Nav_nav__mobileMenuHeader__qt8mr`,
	"nav__closeButton": `Nav_nav__closeButton__Pg0hK`,
	"nav__mobileLinks": `Nav_nav__mobileLinks__j-qpZ`,
	"nav__mobileLink": `Nav_nav__mobileLink__jux0D`,
	"nav__mobileUser": `Nav_nav__mobileUser__cS+X1`,
	"nav__mobileUserInfo": `Nav_nav__mobileUserInfo__ZSf6E`,
	"nav__mobileUserDetails": `Nav_nav__mobileUserDetails__XKy1M`,
	"nav__mobileUserRole": `Nav_nav__mobileUserRole__2whBg`,
	"nav__mobileLogout": `Nav_nav__mobileLogout__TtEgg`
};
export default ___CSS_LOADER_EXPORT___;
